import React from "react";
import Helmet from "react-helmet";

import { IMessageId } from "infrastructure/localization";
import { useLocalizer, useAppContext } from "ui/hooks";

export interface IScreenContext {
  title: IMessageId;
}

export const ScreenContext = React.createContext<IScreenContext>({} as any);

export interface IScreenInfoProviderProps {
  title: IMessageId;
}

export const ScreenContextProvider: React.FC<IScreenInfoProviderProps> = ({ title, children }) => {
  const appContext = useAppContext();

  const localize = useLocalizer();

  const screenContextValue = {
    title: title
  };

  const getScreenTitle = () => {
    try {
      return ` - ${localize(title)}`;
    } catch (error) {
      return "";
    }
  };

  return (
    <ScreenContext.Provider value={screenContextValue}>
      <Helmet>
        <title>
          {appContext.appInfo.appName}
          {getScreenTitle()}
        </title>
      </Helmet>
      {children}
    </ScreenContext.Provider>
  );
};
